import { GRID_TREE_DATA_GROUPING_FIELD, GridApi } from '@mui/x-data-grid-pro';
import { FileType } from 'components/ButtonComponent/ButtonExport';
import { generateColumnNames, handleExport } from 'utils/ExportUtils';

interface DimensionalViewExportOptions {
  fileName: string;
  // Header for the tree column, e.g. the KTree name, "Measurement" or "Period"
  rowHeader: string;
}

// Exports the rows and columns currently shown in the grid. SheetJS picks CSV or Excel from the file extension.
export function exportDimensionalView(
  apiRef: React.MutableRefObject<GridApi>,
  fileType: FileType,
  { fileName, rowHeader }: DimensionalViewExportOptions
) {
  const fields = generateColumnNames(apiRef);
  const columnNames = fields.map((field) =>
    field === GRID_TREE_DATA_GROUPING_FIELD ? rowHeader : apiRef.current.getColumn(field)?.headerName ?? field
  );
  const extension = fileType === FileType.CSV ? 'csv' : 'xlsx';

  handleExport(apiRef, {
    columnNames,
    keys: fields,
    sheetName: 'data',
    fileName: `${fileName}.${extension}`,
  });
}
